import Utils from "@/components/shared/util";
import { Atom } from "@/store/types";
import _ from "lodash";
import SVG from "svg.js";

const defaultWidthAndHeight = { width: 10, height: 40 };

export default class SvgBarGraph {
  container: SVG.Container;
  levelRect: SVG.Rect;
  labels: any;
  title: SVG.Text;
  value1: SVG.Text;
  dimentions: {
    x: number;
    y: number;
    labelOffsetX?: number;
    labelOffsetY?: number;
    width: number;
    height: number;
  };
  backgroundRect: SVG.Rect;
  svgGroup: SVG.G;
  value2: SVG.Text;
  showGreenGrayOnly: boolean;

  constructor(
    container: SVG.Container,
    dimentions: {
      x: number;
      y: number;
      labelOffsetX?: number;
      labelOffsetY?: number;
      width?: number;
      height?: number;
    },
    labels: { title: string },
    showGreenGrayOnly: boolean,
    callback?: Function
  ) {
    this.container = container;
    this.labels = labels;
    this.showGreenGrayOnly = showGreenGrayOnly;

    this.dimentions = Object.assign({}, dimentions, defaultWidthAndHeight);
    if (!callback) {
      callback = _.noop;
    }
    this.backgroundRect = this.container
      .rect(this.dimentions.width, this.dimentions.height)
      .move(this.dimentions.x, this.dimentions.y)
      .fill(Utils.getLevelColor(0, this.showGreenGrayOnly));

    this.levelRect = this.container
      .rect(this.dimentions.width, this.dimentions.height)
      .move(this.dimentions.x, this.dimentions.y);

    this.title = this.container
      .text(labels.title.replace("<sub>2</sub>", "₂")) // TODO Use svg subscripting
      .move(this.dimentions.x + 5, this.dimentions.y - 17)
      .font({ anchor: "middle" });

    const valueOffsetX = this.dimentions.labelOffsetX || 0;
    const valueOffsetY = this.dimentions.labelOffsetY || 0;
    this.value1 = this.container
      .text("")
      .move(
        this.dimentions.x + 5 + valueOffsetX,
        this.dimentions.y + this.dimentions.height - 5 + valueOffsetY
      )
      .font({ anchor: "middle" });

    this.value2 = this.container
      .text("")
      .move(
        this.dimentions.x + 5 + valueOffsetX,
        this.dimentions.y + this.dimentions.height + 10 + valueOffsetY
      )
      .font({ anchor: "middle" });

    //Collect all elements into a group for show/hide
    this.svgGroup = this.container.group();
    this.svgGroup.add(this.backgroundRect);
    this.svgGroup.add(this.levelRect);
    this.svgGroup.add(this.title);
    this.svgGroup.add(this.value1);
    this.svgGroup.add(this.value2);
    this.svgGroup.click(callback);
    this.svgGroup.attr("cursor", "pointer");
  }

  svgGroupRef() {
    return this.svgGroup;
  }

  show() {
    this.svgGroup.show();
  }

  hide(): any {
    this.svgGroup.hide();
  }

  updateData(
    atom: Atom = { time: "", level: 0, legend: "", value: 0, age: 0, alert: "" }
  ) {
    this.svgGroup.show();
    const parts = atom.legend.split("|");
    const text1 = this.value1.clear();
    if (parts[0]) {
      text1.text(parts[0]);
    }
    const text2 = this.value2.clear();
    if (parts[1]) {
      text2.text(parts[1]);
    }
    this.levelRect.fill(
      Utils.getLevelColor(atom.level, this.showGreenGrayOnly)
    );
    const newHeight =
      (this.dimentions.height * Utils.getPercent(atom.level)) / 100;
    this.levelRect
      .height(newHeight)
      .move(
        this.dimentions.x,
        this.dimentions.y + (this.dimentions.height - newHeight)
      );
  }
}
